import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, cultura_de_dados } from '../../../settings';
import { DelayLink, SliderText, CardAccordion, CardAccordionHeader, CardAccordionBody } from '../../../components';

import '../Iniciativas.scss';
import './CulturaDeDados.scss';

class CulturaDeDados extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Cultura de dados - Iniciativas - {texts.title}</title>
        </Helmet>

        <div
          className="iniciativas-home cultura-de-dados-home page-gradient page-gradient--yellow bg-gray"
          ref="cultura-de-dados-home"
        >
          <section className="iniciativas-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className={`card card--page-body card--light-blue`}>
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to={`/estrategias/dentro-de-casa`}
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">Cultura de dados</h1>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Como “tirar da caixinha” mais de 200 profissionais e fazer com que eles mudassem a cultura
                            de trabalho? Esse foi o grande desafio do ano na gestão da equipe interna e o objetivo era
                            claro: promover uma transformação na ANBIMA para estimular o uso de dados nos processos e
                            tomadas de decisão do dia a dia. Criamos dois projetos para fazer isso:
                          </p>
                        </div>
                      </div>

                      {/* <div className="card__image">
												<img src={content.image} />
											</div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="iniciativas-body">
            {/* <div className="container container--large">
							<div className="row">
								
								<div className="col-6">
									<Fade bottom>
										<img src={images.iniciativas.cultura_dados.photo2} className="img-fluid photo1" />
									</Fade>
								</div>
								
								<div className="col-6">
									<Fade bottom>
										<img src={images.iniciativas.cultura_dados.photo2} className="img-fluid photo2" />
									</Fade>
								</div>

							</div>
						</div> */}
            {/* 
						<div className="container container--large">
							<div className="row">
								
								<div className="col-6">
									<Fade bottom>
										<div className="card card--no-border card--pessoas card--secondary">
											<div className="card__content card__content--full">

												<div className="card__content__header">
                      		<h2 className="title title--small light-blue">
														No Ar
													</h2>
												</div>

												<div className="card__content__body">
													
													<div className="scroll_text">
														<p>Blockchain, open banking, uso de dados. Não tinha como fugir: <br />as inovações estão “no ar” e começaram a promover mudanças importantes no mercado que, sem dúvidas, impactariam as atividades da Associação.</p>
														<p>Por isso, criamos uma agenda de palestras para todos os funcionários com nomes de destaque nesse novo cenário. Os encontros começaram no final de 2018, mas se intensificaram em 2019. O objetivo não era oferecer uma formação completa sobre os temas, mas sensibilizar e provocar reflexões que estimulassem cada um a buscar informações e aprender mais sobre os assuntos.</p>
														<p>Os encontros presenciais foram gravados e publicados no workplace – rede social corporativa do Facebook que começamos a utilizar, em 2019, como principal ferramenta de comunicação interna. Por lá, também divulgamos pequenos vídeos com pílulas de conhecimento sobre temas como exponencialidade, inteligência artificial, produtos de dados, entre outros. A TV corporativa que fica disponível nos escritórios também trazia chamadas para esses conteúdos, além de dicas de livros e vídeos no YouTube sobre os temas.</p>
													</div>

												</div>

											</div>
										</div>
									</Fade>
								</div>
								
								<div className="col-6">
									<Fade bottom>
										<div className="card card--no-border card--horas card--secondary">
											<div className="card__content card__content--full">

												<div className="card__content__header">
                      		<h2 className="title title--small light-blue gri_text gri_text--no-transform">
														Insiders
														<span className="gri_label light-gray">GRI <b>103-1, 103-2, 103-3, 404-2</b></span>
													</h2>
												</div>

												<div className="card__content__body">
													<p>Além de sensibilizar as pessoas, era preciso acelerar essa transformação cultural e fazer com que ela se refletisse nas nossas atividades. Foi aí que criamos os Insiders. Um grupo mais enxuto, com 41 funcionários, foi selecionado para passar por treinamentos intensivos sobre ferramentas analíticas e temas que podiam ser postos em prática com rapidez.</p>
												</div>

											</div>
										</div>
									</Fade>
								</div>

							</div>
						</div> */}

            <div className="container container--large container--noar">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <CardAccordion
                      noBorder
                      color="light-blue"
                      header={
                        <CardAccordionHeader>
                          <h2 className="title">No Ar</h2>
                        </CardAccordionHeader>
                      }
                      content={
                        <CardAccordionBody>
                          <div className="row">
                            <div className="col-6">
                              <Fade bottom>
                                <img src={images.iniciativas.cultura_dados.photo2} className="img-fluid photo1" />
                              </Fade>
                            </div>
                            <div className="col-6">
                              <p>
                                Blockchain, open banking, uso de dados. Não tinha como fugir: <br />
                                as inovações estão “no ar” e começaram a promover mudanças importantes no mercado que,
                                sem dúvidas, impactariam as atividades da Associação.
                              </p>
                              <p>
                                Por isso, criamos uma agenda de palestras para todos os funcionários com nomes de
                                destaque nesse novo cenário. Os encontros começaram no final de 2018, mas se
                                intensificaram em 2019. O objetivo não era oferecer uma formação completa sobre os
                                temas, mas sensibilizar e provocar reflexões que estimulassem cada um a buscar
                                informações e aprender mais sobre os assuntos.
                              </p>
                              <p>
                                Os encontros presenciais foram gravados e publicados no workplace – rede social
                                corporativa do Facebook que começamos a utilizar, em 2019, como principal ferramenta de
                                comunicação interna. Por lá, também divulgamos pequenos vídeos com pílulas de
                                conhecimento sobre temas como exponencialidade, inteligência artificial, produtos de
                                dados, entre outros. A TV corporativa que fica disponível nos escritórios também trazia
                                chamadas para esses conteúdos, além de dicas de livros e vídeos no YouTube sobre os
                                temas.
                              </p>
                            </div>
                          </div>
                          <hr />

                          <p>
                            <strong>Seis temas foram abordados ao longo do ano</strong>
                          </p>

                          <SliderText items={cultura_de_dados.no_ar} color={'light-blue'} />
                        </CardAccordionBody>
                      }
                    />
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container container--large container--insiders">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <CardAccordion
                      noBorder
                      color="light-blue"
                      header={
                        <CardAccordionHeader>
                          <h2 className="title">
                            Insiders
                            <span className="gri_label">
                              GRI <b>103-1, 103-2, 103-3, 404-2</b>
                            </span>
                          </h2>
                        </CardAccordionHeader>
                      }
                      content={
                        <CardAccordionBody>
                          <div className="row">
                            <div className="col-6">
                              <p>
                                Além de sensibilizar as pessoas, era preciso acelerar essa transformação cultural e
                                fazer com que ela se refletisse nas nossas atividades. Foi aí que criamos os Insiders.
                                Um grupo mais enxuto, com 41 funcionários, foi selecionado para passar por treinamentos
                                intensivos sobre ferramentas analíticas e temas que podiam ser postos em prática com
                                rapidez.
                              </p>

                              <hr />

                              <p>
                                <strong>Foram seis encontros de oito horas cada</strong>
                              </p>

                              <SliderText items={cultura_de_dados.insiders} color={'light-blue'} />
                            </div>

                            <div className="col-6">
                              <Fade bottom>
                                <img src={images.iniciativas.cultura_dados.photo1} className="img-fluid photo2" />
                              </Fade>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 futuro-container">
                              <div className="card card--no-border card--final">
                                <div className="card__content card__content--full">
                                  <div className="card__content__body">
                                    <p>
                                      Depois de cada treinamento, os insiders se organizavam para multiplicar o
                                      conhecimento absorvido em encontros com os outros funcionários, de forma que a
                                      iniciativa impactasse toda a Associação. No final do programa, foi feito um
                                      hackathon para determinar projetos que seriam implementados em 2020. Dos 15
                                      criados, três foram os finalistas, que se tornaram a meta corporativa para todos
                                      os funcionários. Saiba mais sobre eles:
                                    </p>

                                    <ul className="bullets bullets--light-blue">
                                      <li>
                                        <strong>Jornada dos certificados:</strong> acompanhar os profissionais
                                        certificados é o objetivo desse projeto. Saber quem são, onde estão trabalhando,
                                        quais qualificações procuram, qual o caminho de carreira que estão trilhando. O
                                        mapeamento dessas informações ajudará a reposicionar a ANBIMA como certificadora
                                        no mercado.
                                        <br />
                                        <br />
                                      </li>
                                      <li>
                                        <strong>Central do associado:</strong> o projeto uniu duas ideias: um lugar em
                                        que fosse possível acessar todas as demandas dos associados para a ANBIMA e, ao
                                        mesmo tempo, consultar todas as informações que temos sobre eles.
                                        <br />
                                        Hoje, os pedidos das instituições chegam por diferentes áreas – Certificação,
                                        Supervisão de Mercados, Representação Institucional, Relacionamento. Da mesma
                                        forma, cada uma dessas equipes concentra um tipo de dado sobre as empresas – a
                                        que códigos são aderentes, quais representantes fazem parte dos nossos
                                        organismos, quantos encontros de relacionamento fizemos etc.{' '}
                                      </li>
                                    </ul>

                                    <p>Os dois trabalhos começaram em 2019 e serão finalizados e divulgados em 2020.</p>
                                    <img src={images.dentro_de_casa.image_cultura} className="pessoa" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardAccordionBody>
                      }
                    />
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { CulturaDeDados };
